import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface RecognitionBadgeProps {
  name: string;
  description: string;
  iconName: string;
  earned: boolean;
  earnedDate?: string;
  progress?: number;
}

const RecognitionBadge: React.FC<RecognitionBadgeProps> = ({
  name,
  description,
  iconName,
  earned,
  earnedDate,
  progress = 0,
}) => {
  return (
    <div
      className={`relative bg-card rounded-lg p-6 border transition-all duration-300 ${
        earned
          ? 'border-accent shadow-md hover:shadow-lg'
          : 'border-border opacity-60 hover:opacity-80'
      }`}
    >
      {earned && (
        <div className="absolute -top-2 -right-2">
          <div className="w-8 h-8 bg-success rounded-full flex items-center justify-center shadow-md">
            <Icon name="CheckIcon" size={16} className="text-white" />
          </div>
        </div>
      )}

      <div className="flex flex-col items-center text-center">
        <div
          className={`w-20 h-20 rounded-full flex items-center justify-center mb-4 ${
            earned
              ? 'bg-gradient-to-br from-accent to-primary' :'bg-muted'
          }`}
        >
          <Icon
            name={iconName as any}
            size={40}
            className={earned ? 'text-white' : 'text-muted-foreground'}
          />
        </div>

        <h4 className="text-lg font-headline font-bold text-foreground mb-2">{name}</h4>
        <p className="text-sm text-muted-foreground mb-3">{description}</p>

        {earned && earnedDate && (
          <div className="text-xs text-success font-medium">Earned: {earnedDate}</div>
        )}

        {!earned && progress > 0 && (
          <div className="w-full mt-3">
            <div className="flex items-center justify-between mb-1">
              <span className="text-xs text-muted-foreground">Progress</span>
              <span className="text-xs font-medium text-primary">{progress}%</span>
            </div>
            <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
              <div
                className="h-full bg-primary transition-all duration-300"
                style={{ width: `${progress}%` }}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default RecognitionBadge;